import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
// import { fontFamily, fontFamilySans } from '@clockwise/web-commons/src/styles/type.styles';

const container: CSSProperties = {};

const subscriptionConfirmation: CSSProperties = {
  textAlign: "center",
  width: 450,
  paddingBottom: "50%",
};

const subscriptionConfirmationDescription: CSSProperties = {
  fontSize: 16,
  lineHeight: 1.5,
  color: greys.slate,
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
};

export const styles = {
  container,
  subscriptionConfirmation,
  subscriptionConfirmationDescription,
};
